export const GOV_WIDTH_HAMBURGER_MENU_MOBILE_DEVICES = 768;
export const MAX_HEIGHT_SIDEBAR = 65;
